// extracted by mini-css-extract-plugin
export default {"unauthorizedError":"PrivateRoutes_unauthorizedError__VrNFw","loader":"PrivateRoutes_loader__tcY46"};